import React, { useEffect, useLayoutEffect } from 'react';
import { ContextWrapper } from "./context/AppContext.jsx";
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import SiteLoader from './components/SiteLoader.jsx';
import CustomCursor from './components/CustomCursor.jsx';
import Header from './components/Header.jsx';
import Footer from './components/Footer.jsx';
import Home from './pages/Home.jsx';
import Work from './pages/Work.jsx';
import { gsap } from "../gsap/gsap.min.js";
import { ScrollSmoother } from "../gsap/ScrollSmoother.min.js";
import { ScrollTrigger } from "../gsap/ScrollTrigger.min.js";
import { ScrollSmootherProvider, useScrollSmoother } from './context/ScrollSmootherContext.jsx';
import LegalAndPolicy from './pages/LegalAndPolicy.jsx';


gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

function App() {
	return (
		<BrowserRouter>
			<ScrollSmootherProvider>
				<AppContent />
			</ScrollSmootherProvider>
		</BrowserRouter>
	);
}

function AppContent() {
	//const smoother = useScrollSmoother();
	//const location = useLocation();

	//useEffect(() => {
	//	if (!smoother.current) {
	//		smoother.current = ScrollSmoother.create({
	//			smooth: 1,
	//			effects: true,
	//		});
	//	}

	//	const handleResize = () => {
	//		ScrollTrigger.refresh();
	//	};

	//	window.addEventListener('resize', handleResize);

	//	return () => {
	//		window.removeEventListener('resize', handleResize);
	//		if (smoother.current) smoother.current.kill();
	//	};
	//}, [smoother]);

	//useEffect(() => {
	//	if (smoother.current) {
	//		smoother.current.refresh();
	//		ScrollTrigger.refresh();
	//	}
	//}, [location, smoother]);

	var smoother = null;

	useEffect(() => {
		smoother = ScrollSmoother.create({
			smooth: 1,
			effects: false,
		});
		return () => {
			smoother.kill();
		};
	}, []);

	useEffect(() => {
		if (smoother !== null && smoother.current) {
			smoother.current.refresh();
			ScrollTrigger.refresh();
		}
	}, [location, smoother]);

	//
	//Laciare in caso di Under Construction ------------
	//
	//useEffect(() => {
	//	const handleMouseMove = (e) => {
	//		const { innerWidth, innerHeight } = window;
	//		const centerX = innerWidth / 2;
	//		const centerY = innerHeight / 2;

	//		const deltaX = centerX - e.clientX;
	//		const deltaY = centerY - e.clientY;

	//		const normX = deltaX / centerX;
	//		const normY = deltaY / centerY;

	//		const translateX = normX * 30;
	//		const translateY = normY * 30; 

	//		gsap.to(".under-construction .logo-up", {
	//			x: - translateX,
	//			y: translateY,
	//			duration: 1,
	//			ease: "power1.out"
	//		});

	//		gsap.to(".under-construction .logo-down", {
	//			x: translateX,
	//			y: translateY,
	//			duration: 1,
	//			ease: "power1.out"
	//		});
	//	};

	//	window.addEventListener("mousemove", handleMouseMove);
	//	return () => {
	//		window.removeEventListener("mousemove", handleMouseMove);
	//	};
	//}, []); 

	return (
		<ContextWrapper>
			<main>
				<SiteLoader />
				<CustomCursor />


				{/* Laciare in caso di Under Construction ------------*/}
				{/* */}
				{/*<div className="under-construction">*/}
				{/*	<div className="under-construction-box vh-100 d-flex flex-column justify-content-center align-items-center">*/}
				{/*		<img*/}
				{/*			src="/Content/img/logo-epoca-half.png"*/}
				{/*			alt="logo"*/}
				{/*			className="logo-up mb-1" */}
				{/*		/>*/}
				{/*		<img*/}
				{/*			src="/Content/img/logo-epoca-half.png"*/}
				{/*			alt="logo"*/}
				{/*			className="logo-down" */}
				{/*		/>*/}
				{/*		<h1*/}
				{/*			style={{ minWidth: '200px' }}*/}
				{/*			className="under-construction-title text-center mt-3 fs-6 position-absolute mt-10 pt-10 text-white fw-light text-uppercase">Coming soon</h1>*/}
				{/*	</div>*/}
				{/*</div>*/}
				<Header />
				<div id="smooth-wrapper">
					<div id="smooth-content">
						<Routes>
							<Route path="/" element={<Home />} />
							<Route path="/home/:sectionSlug?" element={<Home />} />
							<Route path="/works/:workSlug?" element={<Work />} />

							<Route path="/cookie-policy" element={<LegalAndPolicy pageId={'f06878ff-4a33-4f34-8312-549671838431'} />} />
							<Route path="/privacy-policy" element={<LegalAndPolicy pageId={'1fa99e26-5ec6-410c-b3a9-61eb19b9bc23'} />} />
							<Route path="/note-legali" element={<LegalAndPolicy pageId={'4558bf28-7752-4bdd-bc13-faf62fca3424'} />} />
						</Routes>
						<Footer />
					</div>
				</div>
			</main>
		</ContextWrapper>
	);
}

export default App;
